import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia.cancellation.documentupload.Unable to Download',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    uploadFailedMessage: {
        id: 'twia.cancellation.documentupload.The document could not be uploaded. Please try again later or contact TWIA at (800) 788-8247.',
        defaultMessage: 'The document could not be uploaded. Please try again later or contact {uwCompanyName} at {contactNumber}.',
    },

});
